import React, { useEffect, useState } from "react";
import { Download, X, Smartphone } from "lucide-react";

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [showIOSHint, setShowIOSHint] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem("vtc_install_dismissed");
    if (dismissed) return;

    // Detect iOS
    const ua = window.navigator.userAgent;
    const iOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    const standalone = window.navigator.standalone === true || window.matchMedia("(display-mode: standalone)").matches;
    if (iOS && !standalone) {
      setIsIOS(true);
      setTimeout(() => setShowIOSHint(true), 5000);
    }

    const onBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setTimeout(() => setShow(true), 3500);
    };
    window.addEventListener("beforeinstallprompt", onBeforeInstall);
    return () => window.removeEventListener("beforeinstallprompt", onBeforeInstall);
  }, []);

  const onInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === "accepted" || outcome === "dismissed") {
      setShow(false);
      setDeferredPrompt(null);
      localStorage.setItem("vtc_install_dismissed", "1");
    }
  };

  const onDismiss = () => {
    setShow(false);
    setShowIOSHint(false);
    localStorage.setItem("vtc_install_dismissed", "1");
  };

  if (!show && !showIOSHint) return null;

  return (
    <div
      data-testid="install-prompt"
      className="fixed top-24 right-4 z-40 w-[calc(100%-2rem)] max-w-sm bg-[#0F1115] border border-[#D4AF37]/30 rounded-2xl shadow-2xl p-4 backdrop-blur-xl"
      style={{ animation: "fadeUp 0.5s ease-out forwards" }}
    >
      <button
        onClick={onDismiss}
        data-testid="install-prompt-close"
        className="absolute top-3 right-3 w-7 h-7 rounded-full bg-white/5 hover:bg-white/10 flex items-center justify-center text-white/60"
      >
        <X size={14} />
      </button>

      <div className="flex items-start gap-4">
        <img
          src="/brand/vd-avatar-128.png"
          alt="VlaDriver VTC"
          width="56"
          height="56"
          loading="lazy"
          decoding="async"
          className="w-14 h-14 rounded-xl ring-1 ring-[#D4AF37]/40 shrink-0"
        />
        <div className="flex-1 pr-5">
          <h3 className="font-serif text-lg text-white mb-1">Installer VlaDriver VTC</h3>
          {isIOS ? (
            <p className="text-xs text-white/60 leading-relaxed">
              Sur iPhone : appuyez sur <Smartphone size={11} className="inline mx-1" /> partage puis "Sur l'écran d'accueil" pour installer l'application.
            </p>
          ) : (
            <p className="text-xs text-white/60 leading-relaxed">
              Accédez à nos services en un clic depuis votre écran d'accueil. Réservation rapide hors ligne, notifications de chauffeur.
            </p>
          )}
        </div>
      </div>

      {!isIOS && deferredPrompt && (
        <button
          onClick={onInstall}
          data-testid="install-prompt-btn"
          className="w-full mt-4 btn-gold rounded-full py-2.5 text-sm font-semibold flex items-center justify-center gap-2"
        >
          <Download size={14} /> Installer l'application
        </button>
      )}
    </div>
  );
};

export default InstallPrompt;
